import { Link as RRDLink } from 'react-router-dom'
import styled from 'styled-components'
import { GREEN, GREY_DARK } from '../../utils/colors'

export const Container = styled.div`
  h3 {
    margin-bottom: 44px;
  }
`

export const Info = styled.div`
  margin-top: 43px;
  max-width: 515px;
  font-size: 12px;
  line-height: 26px;
  color: ${GREY_DARK};
`

export const SmallLink = styled(RRDLink)`
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;
  color: #45b366;
`

export const TypeExamsContainer = styled.div`
  .container_exams {
    margin-top: 60px;
    margin-bottom: 60px;
    overflow: auto;
    height: 419px;
  }
`

export const InfoContainer = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 33px;
    margin-top: 35px;

    a {
      color: ${GREEN};
    }

    img {
      width: 22px;
      margin-right:17px;
    }

    .info_content {
      max-width: 543px;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: left;
      color: ${GREY_DARK};
    }
`
